import { type DialogProps } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../shared/components/ModalBasic";
import styles from "./styles.module.css";

interface Props extends DialogProps {
  childId?: string;
  onOk?: () => void;
  closeModal?: () => void;
  onCancel?: () => void;
  children?: React.ReactNode;
  className?: string;
}

export const FolderNameChangeModal: FC<Props> = ({
  childId,
  onOk,
  closeModal,
  onCancel,
  children,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <ModalBasic
      title={t("name_change_modal.title")}
      hasCloseButton
      closeModal={closeModal}
      hasFooter
      buttonOkText={t("name_change_modal.change_button")}
      onOk={onOk}
      onCancel={onCancel}
      {...props}
      className={styles["modal"]}
    >
      <div className={classNames(styles.container, className)}>{children}</div>
    </ModalBasic>
  );
};
